import { useUSSDInputlogs } from "../ussd_services/useUSSDInputLogs";

export const ussdServicesHooks: Record<string, any> = {
  ussd_input_logs: useUSSDInputlogs,
};

export const ussdServicesTabs = [
  { key: "ussd_input_logs", label: "USSD Input Logs" },
];
